export interface CookieConsent {
  essential: boolean; // Always true - required for app functionality
  analytics: boolean; // PostHog, Vercel Analytics
  errorMonitoring: boolean; // Sentry
  functional: boolean; // User preferences in localStorage
  timestamp: number; // When consent was given
  version: string; // Policy version
}

export enum CookieCategory {
  ESSENTIAL = 'essential',
  ANALYTICS = 'analytics',
  ERROR_MONITORING = 'errorMonitoring',
  FUNCTIONAL = 'functional'
}

export const DEFAULT_CONSENT: CookieConsent = {
  essential: true, // Always required
  analytics: false,
  errorMonitoring: false,
  functional: false,
  timestamp: 0,
  version: '1.0'
};

export const COOKIE_STORAGE_KEY = 'weeklyreview_cookie_consent';
export const COOKIE_BANNER_SHOWN_KEY = 'weeklyreview_banner_shown';

export interface CookieCategoryInfo {
  name: string;
  description: string;
  required: boolean;
  technologies: string[];
}

export const COOKIE_CATEGORIES: Record<CookieCategory, CookieCategoryInfo> = {
  [CookieCategory.ESSENTIAL]: {
    name: 'Essential Cookies',
    description: 'These cookies are necessary for the website to function and cannot be switched off. They are usually only set in response to actions made by you which amount to a request for services.',
    required: true,
    technologies: ['Convex Authentication', 'Next.js Session Management']
  },
  [CookieCategory.ANALYTICS]: {
    name: 'Analytics Cookies',
    description: 'These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us know which pages are most popular.',
    required: false,
    technologies: ['PostHog Analytics', 'Vercel Analytics']
  },
  [CookieCategory.ERROR_MONITORING]: {
    name: 'Error Monitoring',
    description: 'These cookies help us identify and fix technical issues to improve your experience. They collect information about errors and performance.',
    required: false,
    technologies: ['Sentry Error Tracking']
  },
  [CookieCategory.FUNCTIONAL]: {
    name: 'Functional Cookies',
    description: 'These cookies enable enhanced functionality and personalization, such as remembering your preferences and settings.',
    required: false,
    technologies: ['Calendar View Preferences', 'First Day of Week Setting']
  }
};